module.exports = __webpack_public_path__ + "img/consorcio.b701768.png";